/**
 * The sign-up page's Request access form (PB-87, D125 A). The server
 * (`functions/src/functions/requestAccess.ts`) saves the request and emails
 * the admin inbox, with its own limits; this only calls it.
 */
import { functionUrl } from '@/services/functionsUrl'
import { logger } from '@/services/logger'

export type RequestAccessResult = 'sent' | 'too-many' | 'failed'

export async function requestAccess(request: {
  firstName: string
  lastName: string
  email: string
  source: 'uat-signup-page' | 'tenant-invite'
}): Promise<RequestAccessResult> {
  try {
    const res = await fetch(functionUrl('requestAccess'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    })
    if (res.ok) return 'sent'
    logger.warn('[requestAccess] refused', { status: res.status })
    return res.status === 429 ? 'too-many' : 'failed'
  } catch (err) {
    logger.error('[requestAccess] request failed', err)
    return 'failed'
  }
}
